import React from 'react';
import { Link } from 'react-scroll';

const Footer = () => {
  const socialLinks = [
    { name: 'Instagram', url: 'https://www.instagram.com/vishwassd?igsh=MXNndHowczR0NnRyNA%3D%3D'},
    { name: 'YouTube', url: 'https://www.youtube.com/@vsd_81'},
    { name: 'Threads', url: 'https://www.threads.com/@vishwassd?xmt=AQG0sZEfUf5NZBPZEkjcjFd2p5MzitGidDyGqBuT971zfVE'},

  ];

  const navLinks = [
    { to: 'home', label: 'Home' },
    { to: 'about', label: 'About' },
    { to: 'achievements', label: 'Achievements' },
    { to: 'gallery', label: 'Gallery' },
    { to: 'skills', label: 'Story' },
    { to: 'sponsorship', label: 'Sponsorship' },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-darker overflow-hidden py-8 md:py-12">
      {/* Gradient Glow Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0505] to-black"></div>
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] rounded-full opacity-10 blur-3xl bg-primary"></div>
      </div>

      {/* VISHWAS Background Watermark integrated directly in footer */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden opacity-[0.03]">
        <span className="font-heading text-[22vw] text-white leading-none tracking-tighter whitespace-nowrap">
          VISHWAS
        </span>
      </div>

      {/* Top border accent */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-primary to-transparent"></div>

      {/* Checkered pattern */}
      <div className="absolute top-4 right-6 grid grid-cols-6 gap-[2px] opacity-20 pointer-events-none">
        {[...Array(24)].map((_, i) => (
          <div
            key={i}
            className={`w-2.5 h-2.5 ${
              (Math.floor(i / 6) + i) % 2 === 0 ? 'bg-white' : 'bg-transparent'
            }`}
          ></div>
        ))}
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-12 gap-6 md:gap-8 pb-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-5">
            <Link to="home" smooth duration={800} className="cursor-pointer inline-block mb-3">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center">
                  <span className="font-heading text-lg text-black tracking-tighter font-bold">V</span>
                </div>
                <div>
                  <span className="font-heading text-lg tracking-widest text-white block leading-none font-bold">
                    VISHWAS
                  </span>
                  <span className="text-[10px] tracking-[0.3em] text-primary uppercase font-mono">
                  SD
                  </span>
                </div>
              </div>
            </Link>

            <p className="text-xs md:text-sm text-white/50 leading-relaxed max-w-md mb-4">
              National champion, off-road racer, and motorsport athlete. Two decades on the throttle — chasing the podium and the next horizon.
            </p>

         
          </div>

          {/* Navigate */}
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <h4 className="font-heading text-xs md:text-sm text-white tracking-[0.25em] uppercase mb-3 flex items-center gap-2 font-bold">
              <span className="w-1.5 h-1.5 bg-primary"></span>
              Explore
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    smooth
                    duration={800}
                    offset={-100}
                    className="text-xs md:text-sm text-white/50 hover:text-primary cursor-pointer transition-colors block"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <h4 className="font-heading text-xs md:text-sm text-white tracking-[0.25em] uppercase mb-3 flex items-center gap-2 font-bold">
              <span className="w-1.5 h-1.5 bg-primary"></span>
              Connect
            </h4>
            <ul className="space-y-2">
              {socialLinks.map((social) => (
                <li key={social.name}>
                  <a
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs md:text-sm text-white/50 hover:text-primary transition-colors block"
                  >
                    {social.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-4 lg:col-span-3">
            <h4 className="font-heading text-xs md:text-sm text-white tracking-[0.25em] uppercase mb-3 flex items-center gap-2 font-bold">
              <span className="w-1.5 h-1.5 bg-primary"></span>
              Direct
            </h4>
            <div className="space-y-3">
              <div>
                <span className="text-[10px] tracking-[0.2em] text-white/30 uppercase block font-mono">
                  Email
                </span>
                <a
                  href="mailto:rvishwas81@gmail.com"
                  className="text-xs md:text-sm font-mono text-white hover:text-primary transition-colors"
                >
                  rvishwas81@gmail.com
                </a>
              </div>
              <div>
                <span className="text-[10px] tracking-[0.2em] text-white/30 uppercase block font-mono">
                  Phone
                </span>
                <a
                  href="tel:+919986712035"
                  className="text-xs md:text-sm font-mono text-white hover:text-primary transition-colors"
                >
                  +919986712035
                </a>
              </div>
              <div>
                <span className="text-[10px] tracking-[0.2em] text-white/30 uppercase block font-mono">
                  Based In
                </span>
                <span className="text-xs md:text-sm font-mono text-white">
                  Bengaluru, Karnataka· India
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-[1px] bg-white/10"></div>

        {/* Bottom Bar */}
        <div className="pt-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[10px] md:text-xs tracking-[0.15em] text-white/40 uppercase font-mono text-center sm:text-left">
            © {currentYear} Vishwas S.D. · All Rights Reserved
          </p>


          <Link
            to="home"
            smooth
            duration={1000}
            className="text-[10px] md:text-xs tracking-[0.15em] text-white/40 hover:text-primary uppercase font-mono cursor-pointer transition-colors"
          >
            Back to Top
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;